import { assert } from 'chai';
import httpMocks from 'node-mocks-http';

import checkRecorderModule from './checkRecorderModule';

describe('checkRecorderModule', () => {
    it('should call next() on valid module', (done) => {
        const req = httpMocks.createRequest({ body: { module: 'broker' } });
        const res = httpMocks.createResponse();
        checkRecorderModule(req, res, done);
    });

    it('should return 400 without module', (done) => {
        const req = httpMocks.createRequest({ body: {} });
        const res = httpMocks.createResponse();
        checkRecorderModule(req, res);
        assert.equal(400, res._getStatusCode()); // eslint-disable-line no-underscore-dangle
        done();
    });

    it('should return 400 with invalid module', () => {
        const req = httpMocks.createRequest({ body: { module: 'invalid' } });
        const res = httpMocks.createResponse();
        checkRecorderModule(req, res);
        assert.equal(400, res._getStatusCode()); // eslint-disable-line no-underscore-dangle
    });
});
